import { render } from "./UserAccoutingDeatils.vue?vue&type=template&id=ac40495a&scoped=true"
import script from "./UserAccoutingDeatils.vue?vue&type=script&lang=js"
export * from "./UserAccoutingDeatils.vue?vue&type=script&lang=js"

import "./UserAccoutingDeatils.vue?vue&type=style&index=0&id=ac40495a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac40495a"]])

export default __exports__